module.exports = __webpack_public_path__ + "img/bg.524b0a0e.svg";